<template>
  <div class="page page-bg">
    <div class="page__bd">
      <div class="weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">公司名称</label>
            <span class="weui-form-preview__value">{{form.partnerEnterprise.name}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">社会信用代码</label>
            <span class="weui-form-preview__value">{{form.partnerEnterprise.businessCode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">地址</label>
            <span class="weui-form-preview__value">{{form.partnerEnterprise.addr}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">所属行业</label>
            <span class="weui-form-preview__value">{{form.partnerEnterprise.industry}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">注册时间</label>
            <span class="weui-form-preview__value">{{form.partnerEnterprise.regTime}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">添加时间</label>
            <span class="weui-form-preview__value">{{form.createTime}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.category == 10 && form.status == 10">
            <label class="weui-form-preview__label">状态</label>
            <div class="weui-form-preview__value">
              <span class="weui-link">待对方同意</span>
            </div>
          </div>
        </div>
      </div>

      <div v-if="form.userList">
        <div class="weui-form-preview" v-for="item in form.userList" :key="item.id">
          <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">联系人</label>
              <span class="weui-form-preview__value">{{item.partnerUserAccount.realname}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">联系电话</label>
              <span class="weui-form-preview__value">{{item.partnerUserAccount.mobile}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">对方身份</label>
              <span class="weui-form-preview__value" v-if="item.customer">客户</span>
              <span class="weui-form-preview__value" v-if="item.distributor">代理商</span>
              <span class="weui-form-preview__value" v-if="item.servicer">服务商</span>
              <span class="weui-form-preview__value" v-if="item.supplier">供应商</span>
            </div>
            <div class="weui-form-preview__item" v-if="item.remark">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value remark">{{item.remark}}</span>
            </div>
          </div>
        </div>      
      </div>
      <div v-if="!form.userList">
        <div class="weui-form-preview">
          <div class="weui-form-preview__bd">
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">联系人</label>
              <span class="weui-form-preview__value">
                {{form.partnerUserAccount.realname}}
                <span class="iconfont icon-lizhi span-default" v-if="form.hasOwnProperty('jobStatus') && form.jobStatus == 1"></span>
              </span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">联系电话</label>
              <span class="weui-form-preview__value">{{form.partnerUserAccount.mobile}}</span>
            </div>
            <div class="weui-form-preview__item">
              <label class="weui-form-preview__label">对方身份</label>
              <span class="weui-form-preview__value" v-if="form.customer">客户</span>
              <span class="weui-form-preview__value" v-if="form.distributor">代理商</span>
              <span class="weui-form-preview__value" v-if="form.servicer">服务商</span>
              <span class="weui-form-preview__value" v-if="form.supplier">供应商</span>
            </div>
            <div class="weui-form-preview__item" v-if="form.remark">
              <label class="weui-form-preview__label">备注</label>
              <span class="weui-form-preview__value remark">{{form.remark}}</span>
            </div>
          </div>
        </div>         
      </div>

      <div class="weui-form-preview">
        <div class="weui-form-preview__ft">
          <button
            v-if="form.category == 20 && form.status == 10"
            class="weui-form-preview__btn weui-form-preview__btn_primary" 
            @click="confirm">同意</button
          >
          <button 
            v-if="form.category == 20 && form.status == 10"
            class="weui-form-preview__btn weui-form-preview__btn_default"
            @click="refuse">拒绝</button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    let form = this.$route.params.form;
    return {
      form
    }
  },
  methods: {
    confirm() {
      this.reply(20);
    },
    refuse() {
      this.reply(30);
    },
    reply(status) {
      const me = this
      let form = Object.assign({}, this.form, {
        status
      })
      me.$loading({
        url: '/api/account/company_partner/reply',
        jsonData: form,
        method: 'POST',
        loading: true
      }).then(() => {
        me.$weui.toast('回复成功', 2000)
        this.form = form
      }).catch(e => {
        me.$weui.topTips(e.message,3000)
      })
    },
  }
}
</script>

<style scoped>
.remark {
  color: red;
}
</style>